(function () {
  'use strict';
  if (window.MVIconSeries) { window.MVIconSeries.init(document); return; }
  var instances = new Map();
  async function load(section, signal) {
    var tag = (section.dataset.productTag || 'ICON').trim();
    var limit = Math.max(4, Math.min(24, Number(section.dataset.limit) || 24));
    var url = new URL(section.dataset.searchUrl, location.origin);
    url.searchParams.set('view', 'icon-series-data');
    url.searchParams.set('type', 'product');
    url.searchParams.set('q', 'tag:"' + tag.replace(/\\/g, '\\\\').replace(/"/g, '\\"') + '"');
    url.searchParams.set('options[unavailable_products]', 'show');
    var preview = new URL(location.href).searchParams.get('preview_theme_id');
    if (preview) url.searchParams.set('preview_theme_id', preview);
    var products = [], seen = new Set(), pages = 1;
    for (var page = 1; page <= pages; page++) {
      url.searchParams.set('page', String(page));
      var response = await fetch(url.toString(), { credentials: 'same-origin', signal: signal });
      if (!response.ok) throw new Error('Search HTTP ' + response.status);
      var data = JSON.parse(await response.text());
      if (data.icon_series_version !== 1 || data.page !== page || !Array.isArray(data.products) || !Number.isInteger(data.pages) || data.pages < 0 || data.pages > 500) throw new Error('Missing or invalid Icon Series search template.');
      pages = data.pages;
      data.products.forEach(function (product) {
        if (!Array.isArray(product.tags) || !product.tags.includes(tag) || !product.url || seen.has(product.id)) return;
        seen.add(product.id); products.push(product);
      });
    }
    products.sort(function (a, b) { return Number(b.created) - Number(a.created); });
    products = products.slice(0, 250); // Source JP(): newest 250 products.
    products.sort(function (a, b) { return category(a.type) - category(b.type); });
    var cards = products.flatMap(expand);
    return section.dataset.showAll === 'false' ? cards.slice(0, limit) : cards;
  }
  function category(type) {
    var t = (type || '').toLowerCase();
    var matches = [t.includes('tee') || t.includes('t-shirt') || (t.includes('shirt') && !t.includes('sweatshirt')), t.includes('tank'), t.includes('hoodie') || t.includes('sweatshirt') || t.includes('crewneck'), t.includes('hat') || t.includes('cap') || t.includes('beanie'), t.includes('sticker') || t.includes('decal'), t.includes('koozie') || t.includes('coozie') || t.includes('cozy')];
    var index = matches.indexOf(true); return index < 0 ? 6 : index;
  }
  function hasKids(variants) {
    return variants.some(function (v) { return (v.options || []).some(function (o) { return /toddler|youth|kids|^(2t|4t|6t)$|^y(8|10|12|14|16)$/i.test(o.value.trim()); }); });
  }
  function expand(product) {
    var variants = product.variants || [], groups = new Map();
    variants.forEach(function (v) {
      var color = (v.options || []).find(function (o) { return /^(color|colour)$/i.test(o.name); });
      if (color && color.value) { if (!groups.has(color.value)) groups.set(color.value, []); groups.get(color.value).push(v); }
    });
    if (groups.size < 2) return [Object.assign({}, product, {kids:hasKids(variants)})];
    return Array.from(groups, function (entry) {
      var color = entry[0], list = entry[1];
      var cheapest = list.reduce(function (a,b) { return Number(a.amount) <= Number(b.amount) ? a : b; });
      var imageVariant = list.find(function (v) { return v.image; });
      var selected = list.find(function (v) { return v.available; }) || list[0];
      var url = new URL(product.url, location.origin);
      url.searchParams.set('variant', String(selected.id));
      return Object.assign({}, product, {id: String(product.id) + '-' + color, title:product.title + ' — ' + color, price:cheapest.price, image:imageVariant ? imageVariant.image : product.image, url:url.pathname + url.search, kids:hasKids(list)});
    });
  }
  function build(grid, products) {
    var fragment = document.createDocumentFragment();
    products.forEach(function (product) {
      var card = document.createElement('div'); card.className = 'icon-product-card';
      var link = document.createElement('a'); link.className = 'icon-product-image'; link.href = product.url;
      link.setAttribute('aria-label', product.title);
      if (product.image) {
        var img = document.createElement('img'); img.src = product.image; img.alt = product.title;
        img.width = 700; img.height = 700; img.loading = 'lazy'; img.decoding = 'async'; link.appendChild(img);
      } else {
        var placeholder = document.createElement('span'); placeholder.className = 'icon-image-placeholder';
        placeholder.textContent = 'Image unavailable'; link.appendChild(placeholder);
      }
      var info = document.createElement('div'); info.className = 'icon-product-info';
      var titleLink = document.createElement('a'); titleLink.href = product.url;
      var title = document.createElement('h3'); title.textContent = product.title; titleLink.appendChild(title);
      var price = document.createElement('div'); price.className = 'icon-price';
      // Shopify money formatting can include encoded spaces/entities. Decode as text only.
      var decoder = document.createElement('textarea'); decoder.innerHTML = product.price;
      price.textContent = decoder.value;
      var priceRow = document.createElement('div'); priceRow.className = 'icon-price-row'; priceRow.appendChild(price);
      if (product.kids) {
        var badge = document.createElement('span'); badge.className = 'icon-kids-badge';
        badge.append(document.createTextNode('Available'), document.createElement('br'), document.createTextNode('In Kids'));
        priceRow.appendChild(badge);
      }
      info.append(titleLink, priceRow); card.append(link, info); fragment.appendChild(card);
    });
    grid.replaceChildren(fragment);
  }
  function init(root) {
    var sections = Array.from(root.querySelectorAll('[data-icon-series]'));
    if (root.matches && root.matches('[data-icon-series]')) sections.unshift(root);
    sections.forEach(function (section) {
      if (instances.has(section)) return;
      var controller = new AbortController(); instances.set(section, controller);
      var grid = section.querySelector('[data-icon-grid]');
      var status = section.querySelector('[data-icon-status]');
      load(section, controller.signal).then(function (products) {
        if (controller.signal.aborted || !section.isConnected) return;
        build(grid, products); grid.setAttribute('aria-busy', 'false');
        status.hidden = products.length > 0;
        if (!products.length) status.textContent = section.dataset.designMode ? 'No matching products. Check the exact tag, Active status, Online Store publication and search visibility.' : 'No products available yet.';
      }).catch(function (error) {
        if (controller.signal.aborted) return;
        grid.setAttribute('aria-busy', 'false');
        status.textContent = section.dataset.designMode ? 'Check that templates/search.icon-series-data.liquid is saved in this same theme, then reload.' : 'Products could not load. Please refresh the page.';
        console.error('[Icon Series]', error);
      });
    });
  }
  window.MVIconSeries = { init: init };
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
  document.addEventListener('shopify:section:unload', function (e) {
    instances.forEach(function (controller, section) {
      if (section === e.target || e.target.contains(section)) { controller.abort(); instances.delete(section); }
    });
  });
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { init(document); }, { once: true });
  else init(document);
})();
